// extracted by mini-css-extract-plugin
export default {"reviewCard":"ReviewCard_reviewCard__4veBr","reviewCard__img":"ReviewCard_reviewCard__img__VP7oC","reviewCard__content":"ReviewCard_reviewCard__content__btAH0"};